export default __webpack_public_path__ + "static/media/ic_loyalty_noti.86dc8958.svg";